import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { ItemTransferDuration } from 'entities/ticket/ui/direction-detail'
import { AirportChange } from 'entities/ticket/ui/direction-detail/ui/airport-change'
import { BaggageRecheck } from 'entities/ticket/ui/direction-detail/ui/baggage-recheck'

import { prepareTimeShow } from 'shared/lib/ticketRender.ts'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'

import s from './styles.module.scss'

interface Props {
  data?: ItemTransferDuration
}

export const TransferDefault = ({ data }: Props) => {
  const { t } = useTranslation()

  const showInfos = data?.is_airport_change || data?.baggage_recheck

  return (
    <div className={s.transferDefault}>
      <AppIcon
        id={AllIcons.TRANSFER}
        className={s.icon}
        width={24}
        height={24}
      />

      <div className={s.box}>
        <p className={clsx(s.title, 'semi-bold-16')}>
          {t('transfer_details.transfer_in_city', { city: data?.name })}
        </p>

        <div className={s.wrapperTransfer}>
          {showInfos && (
            <div className={s.infos}>
              {data?.is_airport_change && <AirportChange />}
              {data?.baggage_recheck && <BaggageRecheck />}
            </div>
          )}

          <p className={clsx('medium-14', s.transferTime)}>
            {t('wait_time_transfer', {
              duration: prepareTimeShow(data?.time),
            })}
          </p>
        </div>
      </div>
    </div>
  )
}
